import { Link } from "react-router-dom";
import { ShieldCheck, Phone, ArrowRight } from "lucide-react";
import { POLICIES, SHOP_PHONE } from "@/lib/policies";
import { Reveal } from "@/components/motion";

export default function Policies() {
  return (
    <div className="min-h-screen bg-[#050505] pt-32 pb-24 px-6 lg:px-12" data-testid="policies-page">
      <div className="max-w-3xl mx-auto">
        <p className="overline text-xs text-[#d4af37] mb-4 flex items-center gap-3"><span className="w-8 h-px bg-[#d4af37]" /> Booking Policies</p>
        <h1 className="font-display text-4xl lg:text-6xl text-white mb-4">The <span className="italic text-[#d4af37]">fine print</span></h1>
        <p className="text-white/50 font-body mb-16 max-w-xl">A little structure keeps the chair running smoothly for everyone. Here&apos;s what to know before you book.</p>

        <div className="space-y-12">
          {POLICIES.map((p, i) => (
            <Reveal key={p.id} delay={i * 0.08}>
              <div className="border-l-2 border-[#d4af37] pl-6" data-testid={`policy-${p.id}`}>
                <div className="flex items-center gap-3 mb-5">
                  <ShieldCheck className="w-5 h-5 text-[#d4af37]" strokeWidth={1.5} />
                  <h2 className="font-display text-2xl text-white">{p.title}</h2>
                </div>
                <ul className="space-y-3">
                  {p.points.map((pt, j) => (
                    <li key={j} className="text-white/60 font-body text-sm leading-relaxed flex gap-3">
                      <span className="text-[#d4af37] mt-1">—</span>
                      <span>{pt}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="mt-16 border border-white/10 bg-[#0a0a0a] p-8 flex flex-col sm:flex-row sm:items-center justify-between gap-6">
          <div className="flex items-center gap-3 text-white/70 font-body text-sm">
            <Phone className="w-5 h-5 text-[#d4af37]" strokeWidth={1.5} />
            <span>Need to make a change inside 24 hours? Call us at <span className="text-white">{SHOP_PHONE}</span></span>
          </div>
          <Link to="/book" className="group inline-flex items-center gap-2 bg-[#d4af37] text-black px-8 py-3.5 overline text-xs hover:bg-[#c5a028] transition-colors whitespace-nowrap" data-testid="policies-book-btn">
            Book a Chair <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>
      </div>
    </div>
  );
}
